import React from "react";
import { PenLine, Loader2, ShieldCheck } from "lucide-react";
import { SIGNER_META, FIELD_LABEL } from "@/components/contracts/contractUtils";

export default function SignPanel({ role, fields, sign, consent, setConsent, onSubmit, busy }) {
  const mine = fields.filter((f) => f.signer === role);
  const done = (f) => {
    if (f.type === "signature") return !!sign.sigUrl;
    if (f.type === "initials") return !!sign.iniUrl;
    if (f.type === "date") return true;
    return !!sign.values[f.id];
  };
  const required = mine.filter((f) => f.required);
  const doneCount = required.filter(done).length;
  const ready = doneCount === required.length && consent;
  const meta = SIGNER_META[role];
  return (
    <div className="surface-card p-5 space-y-4" data-testid="sign-panel">
      <div>
        <div className="label-eyebrow mb-1" style={{ color: meta.color }}>▮ SIGNING AS {meta.label.toUpperCase()}</div>
        <div className="text-sm text-[var(--ff-text-dim)]">Fill the highlighted boxes on the document. Dates fill in automatically.</div>
      </div>
      <div>
        <div className="flex justify-between font-mono-ui text-[0.65rem] uppercase tracking-[0.15em] mb-1.5">
          <span>Required fields</span><span data-testid="sign-progress">{doneCount}/{required.length}</span>
        </div>
        <div className="h-1.5 bg-[var(--ff-border)]"><div className="h-full transition-[width]" style={{ width: `${required.length ? (doneCount / required.length) * 100 : 100}%`, background: meta.color }} /></div>
      </div>
      <ul className="space-y-1 text-xs max-h-40 overflow-y-auto">
        {mine.map((f) => (
          <li key={f.id} className={`flex justify-between ${done(f) ? "text-emerald-400" : "text-[var(--ff-text-dim)]"}`}>
            <span>{f.label || FIELD_LABEL[f.type]}{f.required ? " *" : ""}</span><span>{done(f) ? "✓" : "—"}</span>
          </li>
        ))}
      </ul>
      <div className="flex gap-2">
        <button onClick={() => sign.openModal("signature")} className="btn-ghost inline-flex items-center gap-1.5 text-xs flex-1 justify-center" data-testid="sign-adopt-signature"><PenLine size={12} /> {sign.sigUrl ? "Change" : "Adopt"} Signature</button>
        {mine.some((f) => f.type === "initials") && (
          <button onClick={() => sign.openModal("initials")} className="btn-ghost inline-flex items-center gap-1.5 text-xs flex-1 justify-center" data-testid="sign-adopt-initials">{sign.iniUrl ? "Change" : "Adopt"} Initials</button>
        )}
      </div>
      <label className="flex items-start gap-2 text-xs cursor-pointer" data-testid="sign-consent">
        <input type="checkbox" checked={consent} onChange={(e) => setConsent(e.target.checked)} className="mt-0.5" data-testid="sign-consent-checkbox" />
        <span>I agree to do business electronically and that my electronic signature is legally binding, the same as a handwritten signature.</span>
      </label>
      <button onClick={onSubmit} disabled={!ready || busy} className="btn-primary w-full justify-center disabled:opacity-40 disabled:cursor-not-allowed" data-testid="sign-submit-btn">
        {busy ? <Loader2 size={14} className="animate-spin" /> : <ShieldCheck size={14} />} Finish &amp; Sign
      </button>
    </div>
  );
}
